import { Component } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormGroup, ValidatorFn } from '@angular/forms';
import { ReorderEvent } from 'devextreme/ui/sortable';
import dxTagBox from 'devextreme/ui/tag_box';
import { delay, map, of, switchMap } from 'rxjs';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { EFormulaScope, TechnicalFeature, ValueTypes } from 'src/app/models';


@Component({
    selector: 'app-products-technical-features-add',
    templateUrl: './products-technical-features-add.component.html',
    styleUrls: ['./products-technical-features-add.component.css'],
    standalone: false
})
export class ProductsTechnicalFeaturesAddComponent extends GenericCrudAddComponent<TechnicalFeature> {

  valueTypes = ValueTypes.map(x => ({ id: x.id, name: this.tr.instant(`enumeration.ValueTypes.${x.name}`) }));
  tagBoxValues?: dxTagBox;
  override resource? = this.api.resources.product.technicalfeatures;

  override initFormGroup(): FormGroup {
    const formulaValidator: AsyncValidatorFn = (control: AbstractControl) => {
      if (!control?.value) return of(null);
      return of(control.value).pipe(
        delay(800),
        switchMap(async (value)=> {
          const valid = await this.api.validateFormula(value, EFormulaScope.TechnicalFeature);
          return valid ? null : { 'invalidFormula': true };
        })
      )
    }
    const codePatternValidator: ValidatorFn = (control: AbstractControl) => {
      if (!control?.value) return null;
      return /^[A-Z0-9]+$/.test(control.value) ? null : { invalidCodeFormat: true };
    };
    
    
    const group = this.fb.group({
      code: ['', [codePatternValidator]],
      name: [],
      valueTypeId: [],
      values: [],
      formula: ['', [], [formulaValidator]],
    });
    return group;
  }

  override async mapFormEntity(): Promise<TechnicalFeature> {
    const technicalFeature = this.form!.value as TechnicalFeature;
    technicalFeature.companyId = this.api.auth.userValue!.lastCompanyId;
    if(!(technicalFeature.valueTypeId === 4 || technicalFeature.valueTypeId === 5)){
      technicalFeature.values = [];
    }
    return technicalFeature;
  }

  reorder(e: ReorderEvent): void {
    const fromIndex = e.fromIndex;
    const toIndex = e.toIndex;
     this.form!.controls['values'].value.splice(toIndex, 0, this.form!.controls['values'].value.splice(fromIndex, 1)[0]);
    setTimeout(() => this.tagBoxValues?.repaint());
  }

}
